function createUrl(candidate) {
  if (candidate) {
    const url = document.createElement('a');

    url.href = candidate;

    return url;
  }
}
function getHost(candidate) {
  const url = createUrl(candidate);

  return url && url.host;
}

export default function getConsoleUrlFromReferrer(referrer, csrfToken) {
  //it is possible that user refresh the page.
  if (window.location.hostname === getHost(referrer)) {
    referrer = '';
  }

  let referrerItem = JSON.parse(localStorage.getItem('referrer') || null);

  let url =
    (referrerItem && referrerItem.csrf === csrfToken && referrerItem.url) || '';

  if (referrer && !url) {
    url = createUrl(referrer);
    url = `${url.protocol}//${url.host}`;
    localStorage.setItem(
      'referrer',
      JSON.stringify({
        csrf: csrfToken,
        url,
      })
    );
  }

  if (url.indexOf('rapid7.okta.com') >= 0) {
    return '';
  }

  return url;
}
